import { defineStore } from "pinia"

export const useAppStore = defineStore("app", {
    state: () => ({
        showLoading: false,
        isChangingCompany: false,
        changingCompanyMessage: null,
        userPosition: [46.603354, 1.888334],
        drawerMenu: [],
    }),
    actions: {
        definedUserPosition() {
            if (!("geolocation" in navigator)) {
                console.warn(
                    "La géolocalisation n'est pas disponible dans ce navigateur",
                )
                return
            }

            navigator.geolocation.getCurrentPosition(
                // Success callback
                (position) => {
                    const latitude = position.coords.latitude
                    const longitude = position.coords.longitude

                    console.log("Position géolocalisée:", {
                        latitude,
                        longitude,
                        accuracy: position.coords.accuracy,
                    })
                    this.userPosition = [latitude, longitude]
                },
                // Error callback
                (error) => {
                    console.error("Erreur de géolocalisation:", error.message)
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            console.warn(
                                "L'utilisateur a refusé la demande de géolocalisation",
                            )
                            break
                        case error.POSITION_UNAVAILABLE:
                            console.warn(
                                "Les informations de localisation ne sont pas disponibles",
                            )
                            break
                        case error.TIMEOUT:
                            console.warn(
                                "La demande de géolocalisation a expiré",
                            )
                            break
                    }
                },
                // Options
                {
                    enableHighAccuracy: true, // Demander la meilleure précision possible
                    timeout: 10000, // Timeout après 10 secondes
                    maximumAge: 0, // Ne pas utiliser de position en cache
                },
            )
        },
    },
})
